export default __webpack_public_path__ + "static/media/homepage-pullquote.f088087f.svg";